import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { User } from '../models/User';
import { CookieService } from 'ngx-cookie-service';
import { Distributor } from '../models/Distributor';
import { HttpService } from './HttpService';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  private _User = new BehaviorSubject<User>(null);
  CurrentUser = this._User.asObservable();

  private _Distributor = new BehaviorSubject<Distributor>(null);
  CurrentDist = this._Distributor.asObservable();

  private userLocale = new BehaviorSubject<string>(null);
  currentUserLocale = this.userLocale.asObservable();

  private _DistributorList = new BehaviorSubject<Distributor[]>(null);
  CurrentDistList = this._DistributorList.asObservable();

  constructor(private cookieServ: CookieService, private http:HttpService) {
    //this._UOM = 'IN';
  }

  public async getCurrentUser():Promise<User> {
    //var curUser = await this.http.RefreshCookies().then(x => {
      return await this.http.RefreshCookies().then(x => {
      debugger;
      if (x.Content) {
        var user = this._User.value;
        if (user) {
          return this.http.GetUserById(user.UserId.toString()).then(y => {
            user = new User().BuildUser(y.Content);
            user.Password = "";
            this.cookieServ.set('TOLO_CurrentUser', JSON.stringify(user), 7);
            return user;
          });
        }
        else {
          if (this.cookieServ.check('TOLO_CurrentUser')) {
            user = new User();
            var cookieUser = this.cookieServ.get("TOLO_CurrentUser");
            if (cookieUser && cookieUser != null && cookieUser != "null") {
              user = Object.assign(user, JSON.parse(this.cookieServ.get('TOLO_CurrentUser')));
              return this.http.GetUserById(user.UserId.toString()).then(y => {
                user = new User().BuildUser(y.Content);
                user.Password = "";
                this.cookieServ.set('TOLO_CurrentUser', JSON.stringify(user), 7);
                return user;
              });
            }
            else {
              return null;
            }
          }
        }        
      }
      else {
        var user = this._User.value;
        if (user) {
          return new User().BuildUser(user);
        }
        else {
          if (this.cookieServ.check('TOLO_CurrentUser')) {
            user = new User();
            var cookieUser = this.cookieServ.get("TOLO_CurrentUser");
            if (cookieUser && cookieUser != null && cookieUser != "null") {
              user = new User().BuildUser(Object.assign(user, JSON.parse(this.cookieServ.get('TOLO_CurrentUser'))));
              user.Password = "";
              this.cookieServ.set('TOLO_CurrentUser', JSON.stringify(user), 7);
              return user;
            }
            else {
              return null;
            }
          }

        }
        return null;
      }
    });

    //return curUser;

    //var user = this._User.value;
    //if (user) {
    //  return new User().BuildUser(user);
    //}
    //else {
      
    //  if (this.cookieServ.check('TOLO_CurrentUser')) {
    //    user = new User();
    //    var cookieUser = this.cookieServ.get("TOLO_CurrentUser");
    //    if (cookieUser && cookieUser != null && cookieUser != "null") {
    //      user = Object.assign(user, JSON.parse(this.cookieServ.get('TOLO_CurrentUser')));
    //      this.setCurrentUser(user);
    //      return new User().BuildUser(user);
    //    }
    //    else {
    //      return null;
    //    }
    //  }

    //}
    //return null;
  }

  public removeCurrentUser() {
    this._User.next(null);
    this.cookieServ.delete('TOLO_CurrentUser');
  }


  public setCurrentUser(user: User) {
    if (user != null) {
      user.Password = "";
    }
    this._User.next(user);
    var testString = JSON.stringify(user);
    this.cookieServ.set('TOLO_CurrentUser', JSON.stringify(user), 7);
  }

  public async getCurrentDist() {
    var dist = this._Distributor.value;
    if (dist) {
      return dist;
    }
    else {
      await this.getCurrentUser().then(x => {
        if (x) {
          dist = x.Distributor;
          
        }
      });
      return dist;
    }
  }

  public setCurrentDist(dist: Distributor) {
    this._Distributor.next(dist);
  }

  public setDistList(list: Distributor[]) {
    this._DistributorList.next(list);
  }

  public async GetDistList():Promise<Distributor[]> {
    var distList = this._DistributorList.value;
    if (distList) {
      return distList;
    }else {
      return await this.http.GetDistributors().then(x => {
        if (x) {
          this.setDistList(x.Content);
        }
        return x.Content;
      });
    }
  }
}
